import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  Output,
  PLATFORM_ID,
  NgZone,
  inject,
} from '@angular/core';
import { isPlatformServer } from '@angular/common';

import { Subject, delay, takeUntil } from 'rxjs';

import { ScrolledPastService } from './scrolled-past.service';

/**
 * Emits event in (scrolledPast) when the element is in viewport
 * or scrolled past
 */
@Directive({
  selector: '[finScrolledPast]',
  standalone: false,
})
export class ScrolledPastDirective implements AfterViewInit, OnDestroy {
  private el = inject<ElementRef<HTMLElement>>(ElementRef);
  private scrolledPastService = inject(ScrolledPastService);
  private ngZone = inject(NgZone);
  private platform = inject(PLATFORM_ID);

  @Output()
  finScrolledPast: EventEmitter<boolean> = new EventEmitter<boolean>();

  private ngDestroyed$ = new Subject<void>();

  ngAfterViewInit(): void {
    if (isPlatformServer(this.platform)) {
      return;
    }
    this.listenToIntersectionEvents();
  }

  ngOnDestroy = (): void => {
    this.ngDestroyed$.next();
    this.ngDestroyed$.complete();
  };

  private listenToIntersectionEvents() {
    const events$ = this.scrolledPastService.listenToElement(this.el.nativeElement);
    // Delay because we need to run in the following change detection cycle
    this.ngZone.runOutsideAngular(() => {
      events$.pipe(delay(1), takeUntil(this.ngDestroyed$)).subscribe(() => {
        this.finScrolledPast.emit(true);
        this.finScrolledPast.complete();
      });
    });
  }
}
